<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';
import { NODE_TYPES } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

const props = defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});
const meta = NODE_TYPES.question;
const preview = computed(() => props.data.text || '(sem pergunta ainda)');
const variableLabel = computed(() =>
  props.data.variable ? `→ guarda em "${props.data.variable}"` : ''
);
const isOptionsMode = computed(() => props.data.mode === 'opcoes');
const options = computed(() => props.data.options || []);
// Distribui os handles das opções ao longo da parte de baixo do card, uma
// por opção - cada opção pode levar direto pro próximo passo do assunto
// dela (ver BotFlows::NodeExecutors::QuestionExecutor), sem precisar de um
// nó de Condição pra cada uma.
const handleTop = index => `${40 + ((index + 1) / (options.value.length + 1)) * 55}%`;
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <Handle type="target" :position="Position.Left" />
    <p class="line-clamp-2 whitespace-pre-wrap">{{ preview }}</p>
    <p v-if="variableLabel" class="mt-1 text-n-slate-9">{{ variableLabel }}</p>

    <template v-if="isOptionsMode">
      <div
        v-for="(option, index) in options"
        :key="index"
        class="flex items-center justify-between gap-2 mt-1 text-[11px] text-n-slate-10"
      >
        <span class="truncate">{{ index + 1 }}. {{ option.label || '(sem texto)' }}</span>
        <Handle
          :id="`option_${index}`"
          type="source"
          :position="Position.Right"
          :style="{ top: handleTop(index) }"
        />
      </div>
      <p v-if="!options.length" class="mt-1 text-n-slate-9">Nenhuma opção ainda.</p>
    </template>
    <Handle v-else type="source" :position="Position.Right" />
  </FlowNodeCard>
</template>
